import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from 'antd';

import './index.css';

import { configureStore, sagaMiddleware } from './config/store';
import App from './app';
import reportWebVitals from './reportWebVitals';
import { rootSaga } from './redux-root/saga';
import { AuthProvider } from 'secure/AuthProvider';

const store = configureStore();
sagaMiddleware.run(rootSaga);

const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(
  <Provider store={store}>
    <AuthProvider>
    <BrowserRouter>
      <ConfigProvider theme={{ 
          token: { colorPrimary: '#722ED1'},
          components: {
            Table: {
              headerBg: "lightgreen",
              rowHoverBg: "lightblue",
            },
            Button: {
              colorPrimary: 'purple',
              colorPrimaryHover: 'red',
            },
          },
      }}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
    </AuthProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
